import React from "react";

const WIN_PUNS = [
  "Goal-geous work!",
  "You're a total keeper!",
  "Back of the net!",
  "Top bins!",
  "A world-class performance!",
  "You've got a great eye for goal!",
  "Absolute screamer of a guess!",
  "Pure class!",
];

function GameMessage({ didWin, answerName, goalDetails }) {
  const pun = WIN_PUNS[Math.floor(Math.random() * WIN_PUNS.length)];
  const isWin = didWin === true;

  return (
    <div
      className={`message-area game-message-${isWin ? "win" : "lose"}`}
      role="status"
    >
      {isWin ? (
        <>
          <div className="game-message-heading win">{pun}</div>
          <span>You correctly identified </span>
          <strong>{answerName}</strong>!
        </>
      ) : (
        <>
          <div className="game-message-heading lose">Full Time!</div>
          <span>The correct player was </span>
          <strong>{answerName}</strong>.
        </>
      )}
      {goalDetails && (
        <div className="goal-details">{goalDetails}</div>
      )}
      <div className="game-message-comeback">
        {isWin
          ? "Come back tomorrow for the next puzzle!"
          : "Don't hang up your boots yet, come back tomorrow for another try!"}
      </div>
    </div>
  );
}

export default GameMessage;
